import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router";
import { Tooltip } from "primereact/tooltip";
import "./CourseFileModal.scss";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import addIcon from "../../assets/addWhiteIcon.png";
import Exclamation from "../../assets/Exclamation.png";
import ModalHeader from "../../components/Header/ModalHeader";
import CourseFileForm from "./CourseFileForm";
import DialogComponent from "../../components/Dialog";
import { deleteContent, getCoursesFile } from "../../services/CourseFileService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";

const getUniqueValuesByKey = (data, key) => {
  const values = data.map((item) => item[key]);
  return [...new Set(values)];
};
function CourseFileView() {
  const [dataitem, setDataitem] = useState([]);
  const [module, setModule] = useState([]);
  const [uploadedDateTime, setUploadedDateTime] = useState([]);
  const [showAddCourseFileModal, setShowAddCourseFileModal] = useState(false);
  const [filters, setFilters] = useState({});
  const [selectedCourseFiles, setSelectedCourseFiles] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const toast = useRef(null);

  const fetchCourseFiles = async (page, pageSize) => {
    try {
      const courseFiles = await getCoursesFile(page, pageSize);
      const courseArray = Array.isArray(courseFiles)
        ? courseFiles
        : Array.isArray(courseFiles?.data)
          ? courseFiles.data
          : courseFiles?.data || [];
      setDataitem(courseArray);
      setPage(courseFiles.page);
      setPageSize(courseFiles.pageSize);
      setTotalCount(courseFiles.total);
    } catch (error) {
      setDataitem([]);
      setTotalCount(0)
      console.error("Error fetching course files:", error);
    }
  };
  useEffect(() => {
    fetchCourseFiles(page, pageSize);
  }, [page, pageSize]);
  useEffect(() => {
    setModule(getUniqueValuesByKey(module, "module"));
    setUploadedDateTime(getUniqueValuesByKey(module, "uploadedDateTime"));
  }, [module]);
  const onFilter = (e, field) => {
    const value = e.target.value.toLowerCase();
    const newFilters = { ...filters };
    newFilters[field] = value;
    setFilters(newFilters);
  };
  const searchTemplate = (field) => {
    const placeholderText = field.includes(".")
      ? `Search ${field
        .split(".")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")}`
      : `Search ${field}`;
    return (
      <InputText
        value={filters[field] || ""}
        onChange={(e) => onFilter(e, field)}
        placeholder={placeholderText}
        className="p-column-filter"
      />
    );
  };
  const filteredData = dataitem.filter((item) =>
    Object.keys(filters).every((key) => {
      let value = "";
      if (key === "name") {
        value = item.CourseFiletranslations?.[0]?.name || "";
      } else if (key === "description") {
        value = item.CourseFiletranslations?.[0]?.description || "";
      } else if (key === "tags") {
        value = item.CourseFiletranslations?.[0]?.tags?.join(", ") || "";
      } else {
        const keys = key.split(".");
        value = keys.reduce((acc, k) => acc?.[k], item) || "";
      }
      return value.toString().toLowerCase().includes(filters[key]);
    })
  );
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };

  const handleCourseFileClick = () => {
    setShowAddCourseFileModal(true);
  };
  const handleModalClose = () => {
    setShowAddCourseFileModal(false);
    fetchCourseFiles(page, pageSize);
  };
  const renderTooltipComponent = (rowData) =>
    rowData.validStatus !== "Valid" && rowData.remarks ? (
      <>
        <Tooltip
          target={`#tooltip_${rowData.id}`}
          mouseTrack
          mouseTrackLeft={2}
          mouseTrackTop={2}
        >
          <div className="tooltip-content">{rowData.remarks}</div>
        </Tooltip>
        <span id={`tooltip_${rowData.id}`} data-testid="Exclamation">
          <img src={Exclamation} alt="Exclamation" />
        </span>
      </>
    ) : null;
  const getBorderClassName = () => "border-second";

  const handleDeleteContent = async () => {
    if (selectedCourseFiles.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "Please select at least one Content to delete.",
        life: 3000,
      });
      return;
    }
    confirmDialog({
      message: `Are you sure you want to delete the selected Content`,
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: async () => {
        let successCount = 0;
        let failedCount = 0;

        for (const content of selectedCourseFiles) {
          try {
            await deleteContent(content.id);
            successCount++;
          } catch (error) {
            console.error("Error deleting content:", error.message);
            toast.current.show({
              severity: "warn",
              summary: "Warning",
              detail: error.message || "Failed to delete content.",
              life: 5000,
            });
            failedCount++;
          }
        }
        if (successCount > 0) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: `Content deleted successfully.`,
            life: 3000,
          });
        }
        setSelectedCourseFiles([]);
        fetchCourseFiles();
      },
    });
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="masterScreen">
        <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '50rem' }}>
          <div className="md:col-6 col-div" />
          <div className="sm:col-12 md:col-6 button_section">
            <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <div className="flex justify-content-end align-items-center mb-2 gap-18 w-full">
                <div className="flex sm:col-12 sm:text-center justify-content-end align-items-end md:col pr-0">
                  <Button
                    className="master-updateBtn"
                    label="Update"
                    severity="info"
                    icon={<img src={updateIconImg} alt="Update icon" />}
                    outlined
                    disabled={selectedCourseFiles.length !== 1}
                    tooltip="Update Content "
                    tooltipOptions={{ position: "bottom", event: "both" }}
                    onClick={() => {
                      if (selectedCourseFiles.length === 1) {
                        const courseFileData = selectedCourseFiles[0];
                        navigate(`/coursefiles?tab=edit`, {
                          state: {
                            mode: "update",
                            course: courseFileData,
                          },
                        });
                        handleCourseFileClick();
                      }
                    }}
                  />
                  <Button
                    className="master-deleteBtn"
                    label="Delete"
                    severity="danger"
                    icon={<img src={deleteIconImg} alt="Delete icon" />}
                    outlined
                    disabled={selectedCourseFiles.length === 0}
                    onClick={handleDeleteContent}
                  />
                  <Button
                    className="addBtn"
                    label="Add New Content"
                    icon={<img src={addIcon} alt="Add icon" />}
                    tooltip="Add New Content"
                    tooltipOptions={{ position: "bottom", event: "both" }}
                    onClick={() => {
                      navigate("/coursefiles?tab=add");
                      handleCourseFileClick();
                    }
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="510px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          totalRecords={totalCount}
          selection={selectedCourseFiles}
          onSelectionChange={(e) => setSelectedCourseFiles(e.value)}
        >
          <Column selectionMode="multiple" header="Select" frozen alignFrozen="left" />
          <Column frozen alignFrozen="left" body={renderTooltipComponent} />
          <Column
            frozen
            alignFrozen="left"
            field="name"
            header="Content Name"
            body={(rowData) => rowData.CourseFiletranslations?.[0]?.name || "-"}
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("name")}
          />
          <Column
            frozen
            alignFrozen="left"
            field="description"
            header="Content Description"
            body={(rowData) => rowData.CourseFiletranslations?.[0]?.description || "-"}
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("description")}
          />
          <Column
            frozen
            alignFrozen="left"
            header="Tags"
            field="tags"
            body={(rowData) =>
              rowData.CourseFiletranslations?.[0]?.tags?.join(", ") || "-"
            }
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("tags")}
          />
          <Column
            frozen
            alignFrozen="left"
            field="Topic.title"
            header="Topic"
            filter
            showFilterMenu={false}
            filterElement={() => searchTemplate("Topic.title")}
          />
          <Column
            frozen
            headerStyle={{ borderRight: "3px solid #d9d9d9", position: "sticky" }}
            bodyStyle={{ borderRight: "3px solid #d9d9d9", position: "sticky" }}
            alignFrozen="left"
            className={getBorderClassName()}
          />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
      </div>
      <DialogComponent
        visible={showAddCourseFileModal}
        onHide={handleModalClose}
        header={
          <ModalHeader onClose={handleModalClose} backText="Back To Content" />
        }
        style={{ width: "100vw", maxWidth: "1000px", height: "100vh" }}
      >
        <CourseFileForm
          mode={selectedCourseFiles.length === 1 ? "update" : "add"}
          courseFile={selectedCourseFiles[0]}
          onClose={handleModalClose}
          onFormSubmit={() => setSelectedCourseFiles([])} />
      </DialogComponent>
      <ConfirmDialog />
    </>
  );
}

export default CourseFileView;